var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"center text-center"},[_c('p',{staticClass:"display-1"},[_vm._v("Page Not Found")]),_c('v-btn',{attrs:{"color":""},on:{"click":function($event){return _vm.$router.push('/locations')}}},[_vm._v("Home")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }